import { useEffect } from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent, usePropertyField } from '@vibesites/runtime/react';
import { isWashingtonState } from '../utils/washington';

/**
 * QualifyingCriteria — a single centered richtext blurb of the community's
 * qualifying rental criteria, matching the Weidner Preferred reference page.
 * The whole block is editable per-property from the inline editor.
 *
 * Washington-only: non-WA properties hide this page (and the header CTAs)
 * and redirect deep links home.
 */
export function QualifyingCriteria() {
  const state = usePropertyField('property_address_state');
  const isWA = isWashingtonState(state);

  useEffect(() => {
    if (isWA) return;
    if (typeof window === 'undefined') return;
    window.location.replace('/');
  }, [isWA]);

  if (!isWA) return null;

  return (
    <section className="pt-10 pb-16 md:pt-14 md:pb-24 bg-[var(--vibe-color-background)]">
      <div className="max-w-3xl md:max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RichTextContent
          path="qualifyingcriteria.blurb"
          label="Page Blurb"
          as="div"
          className="font-body text-sm sm:text-base leading-relaxed text-[var(--vibe-color-text-muted)] [&_p]:mb-4 [&_p:last-child]:mb-0"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'QualifyingCriteria',
  displayName: 'Qualifying Criteria',
  tokens: {
    'qualifyingcriteria.blurb': {
      label: 'Page Blurb',
      type: 'richtext',
      defaultValue:
        '<p>Qualifying Rental Criteria</p><p>Touring: Government issued I.D is required to tour.</p><p>Income: Income verification is required during the application process.</p><p>Credit/Criminal: Unsatisfactory credit may require additional deposit &amp; criminal background checks are required.</p>',
    },
  },
};

(QualifyingCriteria as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default QualifyingCriteria;
